import { qs, qsa } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeUpSplitReveal,
  FadeScaleReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  fadeUp: ".animation-fade-up-reveal",
  fadeUpSplit: ".animation-fade-up-split-reveal",
  fadeScale: ".animation-scale-reveal",
};

export default node => {
  let observer = null;
  const fadeScale = qs(selectors.fadeScale, node);
  const fadeUpSplitItem = qs(selectors.fadeUpSplit, node);
  const fadeUpItems = qsa(selectors.fadeUp, node);
  const textReveals = [];
  let videoReveal = null;

  if (shouldAnimate(node)) {
    videoReveal = new FadeScaleReveal(fadeScale, {
      scaleStart: 1.25,
    });

    if (fadeUpSplitItem) {
      textReveals.push(new FadeUpSplitReveal(fadeUpSplitItem));
    }

    fadeUpItems.forEach(item => {
      textReveals.push(new FadeUpReveal(item));
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    videoReveal.play(0);

    let textDelay = window.theme.animation.delay;
    textReveals.forEach(reveal => {
      reveal.play(textDelay);

      if (reveal.type === "FadeUpSplitReveal") {
        textDelay += reveal.lineCount * window.theme.animation.delayExtraShort;
      } else {
        textDelay += window.theme.animation.delay;
      }
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
